import { ChassisDatePipe } from './date/date.pipe';
import { OrderByPipe } from './orderby/orderby.pipe';
import { KeyValueFilterPipe } from './key-value-filter.pipe';
import { KeysPipe } from './keys.pipe';
import { PluralizePipe } from './plural.pipe';
import { SafePipe } from './safe.pipe';
import { UpperCaseFirstPipe } from './ucfirst/ucfirst.pipe';

export const CHASSIS_SUPPORT_PIPES = [
    ChassisDatePipe,
    OrderByPipe,
    KeyValueFilterPipe,
    KeysPipe,
    PluralizePipe,
    SafePipe,
    UpperCaseFirstPipe,
];


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/pipes/pipes.ts